import script from "./msg.vue?vue&type=script&setup=true&name=liveMsg&lang=js"
export * from "./msg.vue?vue&type=script&setup=true&name=liveMsg&lang=js"

import "./msg.vue?vue&type=style&index=0&id=5cf8b5d6&scoped=true&lang=css"

import exportComponent from "D:\\Jawsro\\company\\hujing\\v3\\hujing_pro_h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5cf8b5d6"]])

export default __exports__